import React, {useState, useContext} from 'react';
import {Box, Stack, Button, Icon} from '@shopify/polaris';
import {EditMinor, ViewMinor} from '@shopify/polaris-icons';
import {IFrameModal} from '@thinkwell/react.polaris';
import EditContent from '../content/EditContent'
import EditContentNode from './EditContent'
import {CourseTreeContext} from '../contexts/CourseTree'
import axios from 'axios'

export default function Content(props) {
  const [courseTree, updateCourseTree] = useContext(CourseTreeContext)
  const [content, setContent] = useState()
  const [active, setActive] = useState(false)

  const {name, meta, content_id, content_name} = props.item

  const onContentClick = async() => {
    if (!content) {
      const url = `${window.location.origin}/content/${content_id}.json`
      const response = await axios({method: 'get', url: url})
      const data = response.data;
      setContent(data)
    }
    setActive(true)
  }

  const onContentSave = (response) => {
    setContent(response)
    props.item.content_name = response.name
    courseTree.updateNode(props.item)
    updateCourseTree(courseTree)
  }

  return (<div className="content">
    <Stack>
      <EditContentNode linkText={props.name || name} title={`Edit ${name}`} item={props.item}/>
      <span className="edit-content"><Button plain icon={<Icon source={EditMinor} />} onClick={onContentClick} /></span>
      { active ?
        <EditContent
          useModal
          linkText={<span></span>}
          active={active}
          item={content}
          type={meta.type}
          onActive={(isActive) => { if (isActive != active) { setActive(isActive) }}}
          onSave={onContentSave}
        /> : null
      }
      <IFrameModal
        title={`View Content ${content_name}`}
        linkTitle={<span className="view-content"><Icon source={ViewMinor} /></span>}
        url={`/content/${content_id}/view.html`}
      />
    </Stack>
  </div>)
}
